import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/icons/arrows/arr-gray-left.svg';
import _imports_1 from '@/assets/icons/actions/ico-btn-ulozit.svg';
const _hoisted_1 = { class: "side-box__header d-flex justify-content-between align-items-center" };
const _hoisted_2 = { class: "atom-back__inner d-flex align-items-center" };
const _hoisted_3 = { class: "d-flex gap-2" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "side-box__title" };
const _hoisted_7 = { class: "side-box__content__form-box overflow-visible" };
const _hoisted_8 = { class: "d-flex flex-wrap" };
import FormInput from "@/components/forms/FormInput.vue";
import FormSelect from "@/components/forms/FormSelect.vue";
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { client } from "@/main";
export default /*@__PURE__*/ _defineComponent({
    __name: 'hwDeviceFormModal',
    props: {
        hwDevice: {},
        transformationFunctionOptions: {},
        isOpen: { type: Boolean },
        readOnly: { type: Boolean }
    },
    emits: ["change", "close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        watch(() => props.isOpen, (isOpen) => {
            if (isOpen) {
                editedDevice.value = { ...props.hwDevice };
            }
        });
        const store = useStore();
        const { t: $t } = useI18n();
        const editedDevice = ref({ ...props.hwDevice });
        const isFormValid = computed(() => {
            return !!(editedDevice.value.manufacturer &&
                editedDevice.value.revision &&
                editedDevice.value.model &&
                editedDevice.value.transformationId &&
                editedDevice.value.technology &&
                (editedDevice.value.technology !== "UDP" || editedDevice.value.port));
        });
        const technologyOptions = computed(() => {
            return [
                { text: $t("lora"), value: "LORA" },
                { text: "UDP", value: "UDP" }
            ];
        });
        async function handleSave(shouldClose = true) {
            store.commit("modals/setWaitingLoader", $t("SAVING"));
            try {
                if (props.hwDevice.hwDeviceId) {
                    const deviceForRequest = editedDevice.value;
                    await client.path("/hwdevices/{hwDeviceId}").method("put").create()({
                        ...deviceForRequest,
                        hwDeviceId: props.hwDevice.hwDeviceId.toString()
                    });
                }
                else {
                    await client.path("/hwdevices").method("post").create()(editedDevice.value);
                }
                const notification = [
                    {
                        text: "HW_DEVICE_SAVED",
                        error: false,
                        params: {
                            hwDeviceModel: editedDevice.value.model
                        }
                    }
                ];
                store.commit("modals/setGlobalNotification", notification);
                emits("change");
                if (shouldClose) {
                    emits("close");
                }
            }
            catch (e) {
                store.commit("modals/setError", e.data.errors);
            }
            store.commit("modals/setWaitingLoader", "");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([{ active: _ctx.isOpen }, "side-box"])
            }, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "side-box__overlay" }, null, -1)),
                _createElementVNode("div", {
                    class: _normalizeClass([{
                            opened: _ctx.isOpen,
                            'last-active': true
                        }, "side-box__inner"]),
                    style: _normalizeStyle([_ctx.isOpen ? '' : 'right: -1500px', { "width": "1200px" }])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                            class: "atom-back atom-back--gray",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _cache[9] || (_cache[9] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                                _createElementVNode("span", null, _toDisplayString(_unref($t)("zpet")), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            (!_ctx.readOnly && _ctx.hwDevice.hwDeviceId)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: _normalizeClass([isFormValid.value ? '' : 'disabled', "btn btn-primary primary-shadow"]),
                                    onClick: _cache[1] || (_cache[1] = ($event) => (handleSave(false)))
                                }, [
                                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "atom-icon" }, [
                                        _createElementVNode("img", { src: _imports_1 })
                                    ], -1)),
                                    _createElementVNode("span", null, _toDisplayString(_unref($t)("SAVE")), 1)
                                ], 2))
                                : _createCommentVNode("", true),
                            (!_ctx.readOnly)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: _normalizeClass([isFormValid.value ? '' : 'disabled', "btn btn-primary primary-shadow"]),
                                    onClick: _cache[2] || (_cache[2] = ($event) => (handleSave()))
                                }, [
                                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "atom-icon" }, [
                                        _createElementVNode("img", { src: _imports_1 })
                                    ], -1)),
                                    (_ctx.hwDevice.hwDeviceId)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref($t)("FINISH_AND_SAVE")), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref($t)("CREATE")), 1))
                                ], 2))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("h2", null, _toDisplayString(_unref($t)("HW_DEVICE")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(FormInput, {
                                disabled: _ctx.readOnly,
                                label: _unref($t)('MANUFACTURER'),
                                placeholder: _unref($t)('MANUFACTURER_PLACEHOLDER'),
                                value: editedDevice.value.manufacturer,
                                class: "mb-4 w-50",
                                "side-box": "",
                                onInput: _cache[3] || (_cache[3] = ($event) => (editedDevice.value.manufacturer = $event))
                            }, null, 8, ["disabled", "label", "placeholder", "value"]),
                            _createVNode(FormInput, {
                                disabled: _ctx.readOnly,
                                label: _unref($t)('REVISION'),
                                placeholder: _unref($t)('REVISION_PLACEHOLDER'),
                                value: editedDevice.value.revision,
                                class: "mb-4 w-50",
                                "side-box": "",
                                onInput: _cache[4] || (_cache[4] = ($event) => (editedDevice.value.revision = $event))
                            }, null, 8, ["disabled", "label", "placeholder", "value"]),
                            _createVNode(FormInput, {
                                disabled: _ctx.readOnly,
                                label: _unref($t)('MODEL'),
                                placeholder: _unref($t)('MODEL_PLACEHOLDER'),
                                value: editedDevice.value.model,
                                class: "mb-4 w-50",
                                "side-box": "",
                                onInput: _cache[5] || (_cache[5] = ($event) => (editedDevice.value.model = $event))
                            }, null, 8, ["disabled", "label", "placeholder", "value"]),
                            _createVNode(FormSelect, {
                                disabled: _ctx.readOnly,
                                items: _ctx.transformationFunctionOptions ?? [],
                                label: _unref($t)('TRANSFORMATION_FUNCTION'),
                                value: _ctx.transformationFunctionOptions?.find((tf) => tf.transformationId === editedDevice.value.transformationId),
                                class: "mb-4 w-50",
                                "item-text": "label",
                                "item-value": "transformationId",
                                "side-box": "",
                                onChange: _cache[6] || (_cache[6] = ($event) => (editedDevice.value.transformationId = $event.transformationId))
                            }, null, 8, ["disabled", "items", "label", "value"]),
                            _createVNode(FormSelect, {
                                disabled: _ctx.readOnly,
                                items: technologyOptions.value,
                                label: _unref($t)('TECHNOLOGY'),
                                value: technologyOptions.value.find((tech) => tech.value === editedDevice.value.technology),
                                class: "mb-4 w-50",
                                "item-text": "text",
                                "item-value": "value",
                                "side-box": "",
                                onChange: _cache[7] || (_cache[7] = ($event) => (editedDevice.value.technology = $event.value))
                            }, null, 8, ["disabled", "items", "label", "value"]),
                            (editedDevice.value.technology === 'UDP')
                                ? (_openBlock(), _createBlock(FormInput, {
                                    key: 0,
                                    type: "number",
                                    disabled: _ctx.readOnly,
                                    label: _unref($t)('PORT'),
                                    placeholder: _unref($t)('PORT_PLACEHOLDER'),
                                    value: editedDevice.value.port,
                                    class: "mb-4 w-50",
                                    "side-box": "",
                                    onInput: _cache[8] || (_cache[8] = ($event) => (editedDevice.value.port = $event))
                                }, null, 8, ["disabled", "label", "placeholder", "value"]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ], 6)
            ], 2));
        };
    }
});
